const configuredOrigin = import.meta.env?.VITE_APP_ORIGIN || 'https://scopeworth.app';

export const APP_ORIGIN = configuredOrigin.replace(/\/$/, '');

export function appUrl(pathname = '/') {
  const path = pathname.startsWith('/') ? pathname : `/${pathname}`;
  return `${APP_ORIGIN}${path}`;
}
